import fdotLayers from './data/fdot.json';
import txdotLayers from './data/txdot.json';
import sfLayers from './data/sfpd.json';
import idot from './data/idot.json';
import dc from './data/dc.json';

export const layerConfiguration = [...fdotLayers, ...txdotLayers, ...sfLayers, ...idot, ...dc];